<template>
	<tbody>
		<template v-for="row in uploads" :key="row.guid">
			<data-collection-upload :upload="row"
															v-on:upload-approved="onUploadApproved"
															v-on:upload-rejected="onUploadRejected"/>
		</template>
	</tbody>
</template>

<script type="text/javascript">
	import { useUserStore } from '@/stores/user'
	import { useFundStore } from '@/stores/fund'
  import FileDownload from "@/mixins/FileDownload";
	import DataCollectionUpload from './DataCollectionUpload'

	export default {
		name: 'DataCollectionUploads',
    props: ['uploads'],
		inheritAttrs: false,

		mixins: [FileDownload],

		components: {
			DataCollectionUpload
		},

		filters: {
		},

		provide: function() {
			return {
			}
		},

		inject: [],

		data() {
			return {
				companies: []
			}
		},

		computed: {
		},

		watch: {

		},

		setup() {
			const userStore = useUserStore()
			const fundStore = useFundStore()
			return {
				userStore,
				fundStore
			}
		},

		created() {
		},

		methods: {

			onUploadApproved(upload, approvedUploadResponse) {
				this.$emit('uploadApproved', upload, approvedUploadResponse)
			},

			onUploadRejected(upload, resp) {
				this.$emit('uploadRejected', upload, resp)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.file-name-col {
		line-break: anywhere;
	}
</style>
